import { useMutation } from '@tanstack/react-query'
import { views } from '../../../v3/views'

type DeleteViewParams = {
  id: string
}

type QueryParams = {
  onMutate?: (params: DeleteViewParams) => void
  onSuccess?: (data: null, params: DeleteViewParams) => void
}

export const useDeleteView = ({ onMutate, onSuccess }: QueryParams) => {
  return useMutation({
    mutationFn: ({ id }: DeleteViewParams) => {
      return views.delete({
        params: {
          path: { view_id: id },
        },
      })
    },
    onMutate,
    onSuccess,
  })
}
